import { render, staticRenderFns } from "./AdminBadge.vue?vue&type=template&id=73eede45&scoped=true&"
import script from "./AdminBadge.vue?vue&type=script&lang=js&"
export * from "./AdminBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73eede45",
  null
  
)

export default component.exports